import CreativeForm from 'common/pages/creative/CreativeForm.tsx'

export const CreativeFormAgency = (props: any) => <CreativeForm {...props} mode={props.mode} agency/>